import { ButtonBase, Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { PersonaAvatar } from 'src/components/PersonaAvatar';
import { AVATAR_TYPE } from 'src/data/persona';

import { useStyles } from './useStyles';

export const PersonaMoreButton = ({
  className,
  onClick,
  disabled,
  badge,
  hasNonDisplayedPersonas,
  ...restProps
}) => {
  const styles = useStyles();

  return (
    <ButtonBase
      className={cx(styles.root, className)}
      onClick={onClick}
      disabled={disabled}
      data-testid="personaMoreButton"
      data-onboarding="PersonaMoreButton"
      {...restProps}
    >
      <PersonaAvatar
        className={styles.avatar}
        avatarType={AVATAR_TYPE.avatarFive}
        hasBadge={badge}
      />

      <Typography className={styles.text}>{hasNonDisplayedPersonas ? 'More' : 'Add'}</Typography>
    </ButtonBase>
  );
};

PersonaMoreButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  badge: PropTypes.bool,
  hasNonDisplayedPersonas: PropTypes.bool,
};

PersonaMoreButton.defaultProps = {
  className: '',
  disabled: false,
  badge: false,
  hasNonDisplayedPersonas: false,
};
